// @flow strict
import {
  type CUSTOM_FIELDS,
  type CUSTOM_FORM_TYPE,
  type CustomForm as CustomFormType,
} from 'src/types/crm';

import * as React from 'react';
import {useApi} from 'src/hooks/useApi';
import CustomForm from 'src/components/crm/jobs/crud/job-details/custom-form/custom-form.jsx';
//$FlowFixMe[nonstrict-import]

type CustomFilterProps = {
  initialValues: CUSTOM_FIELDS[],
  onChange: (data: {
    values: Array<{fieldId: number, value: string | null}>,
    isValid: boolean,
    errors: Array<{fieldId: number, error: string}>,
    formId?: string,
  }) => void,
  customFormList: Array<CustomFormType>,
  isLoadingCustomForm: boolean,
};

export const CustomFilter: React$AbstractComponent<CustomFilterProps, mixed> =
  React.memo<CustomFilterProps>(
    ({
      onChange,
      initialValues,
      customFormList,
      isLoadingCustomForm,
    }: CustomFilterProps): React.Node => {
      const handleOnChange = (
        values: Array<{
          fieldId: number,
          value: string | null,
          fieldType: string,
        }>,
        isValid: boolean,
        errors: Array<{
          fieldId: number,
          error: string,
        }>,
      ) => {
        // $FlowFixMe[unnecessary-optional-chain]
        // $FlowFixMe[prop-missing]
        onChange({values, isValid, errors, formId: customFormList?.[0]?.id});
      };

      return (
        <CustomForm
          fields={Array.isArray(customFormList) ? customFormList : null}
          // $FlowFixMe[incompatible-type]
          onChange={handleOnChange}
          initialValues={initialValues}
          viewType="1"
          showFormTypes={[]}
          checkCondition={false}
        />
      );
    },
  );
